export default __webpack_public_path__ + "static/media/mixed.7be17e2a.jpg";